import React, { useState, useRef, useMemo, useEffect } from 'react';
import './index.less';
import { Form, Space, Button } from 'antd';
import { UpOutlined, DownOutlined } from '@ant-design/icons';

export default function FilterBoxes(props) {
  let {
    formItemArr = [],
    form,
    children = [],
    okButtonProps = {},
    resetButtonProps = {},
    okText = '查询',
    resetText = '重置',
    btnForm = (
      <>
        <Form.Item>
          <Button type="primary" htmlType="submit" shape="round" {...props.okButtonProps}>
            {okText}
          </Button>
        </Form.Item>
        <Form.Item>
          <Button onClick={() => props.form.resetFields()} shape="round" {...props.resetButtonProps}>
            {resetText}
          </Button>
        </Form.Item>
      </>
    ),
    ...formProps
  } = props;

  formItemArr =
    React.Children.toArray(children).length > 0
      ? React.Children.toArray(children)
      : React.Children.toArray(formItemArr);

  const [columnNum, initialIsCollapse, multipleLines] = useMemo(() => {
    let spanSum = 0;
    for (let i = 0; i < formItemArr.length; i++) {
      spanSum += Number(formItemArr[i].props['data-span'] || formItemArr[i].props['span'] || 6);
      if (spanSum > 19) {
        return [i, true, true];
      }
    }
    // 只有一行存在
    return [0, false, false];
  }, [formItemArr]);

  useEffect(() => {
    setIsCollapse(initialIsCollapse);
  }, [initialIsCollapse]);

  const ref = useRef(null);
  const [isCollapse, setIsCollapse] = useState(initialIsCollapse);

  let formItemArrFinal = !isCollapse ? formItemArr : formItemArr.slice(0, columnNum);

  const ChildForm = () => {
    return (
      <div className="TY__main-form" ref={ref}>
        {formItemArrFinal.map((ele) => {
          return (
            <div
              key={ele.key}
              className="main-form-item"
              style={{ gridColumnStart: `span ${ele.props['data-span'] || ele.props['span'] || 6}` }}
            >
              {ele}
            </div>
          );
        })}
        <div className="btn-form">
          <Space size={8}>
            {btnForm}
            {multipleLines && (
              <span className="form-isSretch" onClick={() => setIsCollapse(!isCollapse)}>
                {!isCollapse ? (
                  <>
                    收起
                    <UpOutlined className="icon" />
                  </>
                ) : (
                  <>
                    展开
                    <DownOutlined className="icon" />
                  </>
                )}
              </span>
            )}
          </Space>
        </div>
      </div>
    );
  };

  // 兼容旧版本的套一层form的情况
  if (formProps.onFinish) {
    return (
      <Form {...formProps} form={form}>
        {ChildForm()}
      </Form>
    );
  } else {
    return ChildForm();
  }
}
